import styled from 'styled-components';

export const CoursesWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;
